var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{class:_vm.classes},[(_vm.closable)?_c('span',{staticClass:"close",on:{"click":_vm.close}},[_vm._v("×")]):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_c('p',[_vm._v(_vm._s(_vm.message))])]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }